<template>
  <div
    class="offcanvas offcanvas-end filter-offcanvas"
    style="width: 380px;"
    tabindex="-1"
    ref="offcanvas"
  >
    <div class="bg-top-nav offcanvas-header py-2 px-3">
      <span class="fw-semibold d-flex align-items-center">
        <i class="fa-solid fa-sliders me-2" />
        {{ $t('Filters') }}
        <span v-if="totalActive" class="filter-header-badge ms-2">
          {{ totalActive }}
        </span>
      </span>
      <button
        type="button"
        style="font-size: small;"
        class="btn-close btn-close-white shadow-none"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      />
    </div>

    <div class="offcanvas-body p-0">
      <div
        v-for="section in sections"
        :key="section.key"
        class="filter-section"
      >
        <button
          type="button"
          class="filter-section-header"
          :class="{ 'is-open': expanded[section.key] }"
          @click="toggleSection(section.key)"
        >
          <span class="filter-section-icon">
            <i :class="['fa-solid', section.icon || 'fa-list']" />
          </span>
          <span class="filter-section-title flex-grow-1 text-start">
            {{ $t(section.label) }}
          </span>
          <span v-if="sectionCount(section.key)" class="filter-section-count">
            {{ sectionCount(section.key) }}
          </span>
          <i class="fa-solid fa-chevron-down filter-chevron" />
        </button>

        <transition name="filter-collapse">
          <div v-show="expanded[section.key]" class="filter-section-body">
            <div
              v-if="!section.options || !section.options.length"
              class="text-secondary small px-3 py-3 text-center"
            >
              {{ $t('No Available Data') }}
            </div>
            <template v-else>
              <label
                v-for="opt in section.options"
                :key="opt.id"
                class="filter-option"
                :class="{ 'is-checked': isChecked(section.key, opt.id), 'is-single': section.single }"
              >
                <input
                  v-if="section.single"
                  class="filter-option-input"
                  type="radio"
                  :name="'filter-' + section.key"
                  :value="opt.id"
                  :checked="isChecked(section.key, opt.id)"
                  @click="selectSingle(section.key, opt.id)"
                >
                <input
                  v-else
                  class="filter-option-input"
                  type="checkbox"
                  :value="opt.id"
                  v-model="draft[section.key]"
                >
                <span class="filter-option-check">
                  <i class="fa-solid fa-check" />
                </span>
                <span class="filter-option-label">{{ $t(opt.name) }}</span>
              </label>
            </template>
          </div>
        </transition>
      </div>
    </div>

    <div class="bg-white border-top modal-footer py-2 px-3 d-flex justify-content-between">
      <button
        type="button"
        class="btn btn-sm btn-link text-secondary text-decoration-none"
        :disabled="!totalActive"
        @click="clearAll"
      >
        <i class="fa-solid fa-rotate-left me-1" />
        {{ $t('Clear') }}
      </button>
      <button
        type="button"
        class="btn btn-sm btn-theme px-3"
        @click="applyFilter"
      >
        <i class="fa-solid fa-magnifying-glass me-1" />
        {{ $t('Apply') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sections: {
      type: Array,
      required: true
    },
    value: {
      type: Object,
      required: true
    }
  },
  emits: ['apply', 'close'],
  data() {
    return {
      draft: {},
      expanded: {}
    };
  },
  computed: {
    totalActive() {
      return this.sections.reduce((sum, s) => sum + (this.draft[s.key]?.length || 0), 0);
    }
  },
  methods: {
    sectionCount(key) {
      return this.draft[key]?.length || 0;
    },
    isChecked(key, id) {
      return (this.draft[key] || []).includes(id);
    },
    selectSingle(key, id) {
      // single-select: click selected option again to clear it
      this.draft[key] = this.isChecked(key, id) ? [] : [id];
    },
    toggleSection(key) {
      this.expanded[key] = !this.expanded[key];
    },
    clearAll() {
      this.sections.forEach(s => { this.draft[s.key] = []; });
    },
    applyFilter() {
      const payload = {};
      this.sections.forEach(s => { payload[s.key] = [...(this.draft[s.key] || [])]; });
      this.$emit('apply', payload);
      $(this.$refs.offcanvas).offcanvas('hide');
    }
  },
  mounted() {
    this.sections.forEach(s => {
      this.draft[s.key] = [...(this.value[s.key] || [])];
      this.expanded[s.key] = false;
    });
    $(this.$refs.offcanvas).offcanvas('show');

    $(this.$refs.offcanvas).on('hidden.bs.offcanvas', () => {
      this.$emit('close');
    });
  }
};
</script>

<style scoped>
.filter-offcanvas {
  background-color: #fafafa;
}

.filter-header-badge {
  background-color: rgba(255, 255, 255, 0.25);
  color: #fff;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 700;
  padding: 1px 8px;
  min-width: 22px;
  text-align: center;
}

.filter-section {
  background-color: #fff;
  border-bottom: 1px solid #eef0f2;
}

.filter-section-header {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 12px 16px;
  background: transparent;
  border: none;
  color: #2c2c2c;
  font-weight: 600;
  font-size: 0.9rem;
  transition: background-color 0.15s ease;
}

.filter-section-header:hover {
  background-color: #fff7f1;
}

.filter-section-icon {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: #fdece0;
  color: #E96C15;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.78rem;
  flex-shrink: 0;
}

.filter-section-title {
  letter-spacing: 0.01em;
}

.filter-section-count {
  background: #E96C15;
  color: #fff;
  font-size: 0.7rem;
  font-weight: 700;
  border-radius: 999px;
  padding: 1px 8px;
  min-width: 22px;
  text-align: center;
}

.filter-chevron {
  color: #adb5bd;
  font-size: 0.75rem;
  transition: transform 0.2s ease;
}

.filter-section-header.is-open .filter-chevron {
  transform: rotate(180deg);
  color: #E96C15;
}

.filter-section-body {
  padding: 6px 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow: hidden;
}

.filter-option {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 12px;
  background: #fff;
  border: 1px solid #eceff2;
  border-radius: 8px;
  cursor: pointer;
  user-select: none;
  transition: border-color 0.15s ease, background-color 0.15s ease;
  margin-bottom: 0;
}

.filter-option:hover {
  border-color: #f1cdb1;
  background: #fffaf5;
}

.filter-option.is-checked {
  border-color: #E96C15;
  background: #fff3e8;
}

.filter-option-input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.filter-option-check {
  width: 20px;
  height: 20px;
  border-radius: 6px;
  border: 1.5px solid #ced4da;
  background: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: transparent;
  font-size: 0.7rem;
  flex-shrink: 0;
  transition: all 0.15s ease;
}

.filter-option.is-checked .filter-option-check {
  background: #E96C15;
  border-color: #E96C15;
  color: #fff;
}

.filter-option.is-single .filter-option-check {
  border-radius: 50%;
}

.filter-option-label {
  font-size: 0.88rem;
  color: #2c2c2c;
  line-height: 1.25;
  flex: 1;
  min-width: 0;
  word-break: break-word;
}

.filter-option.is-checked .filter-option-label {
  font-weight: 600;
  color: #d46010;
}

.filter-collapse-enter-active,
.filter-collapse-leave-active {
  transition: max-height 0.22s ease, opacity 0.18s ease;
  overflow: hidden;
}
.filter-collapse-enter-from,
.filter-collapse-leave-to {
  max-height: 0;
  opacity: 0;
}
.filter-collapse-enter-to,
.filter-collapse-leave-from {
  max-height: 1000px;
  opacity: 1;
}
</style>
